module.exports = __webpack_public_path__ + "static/media/stars-header.5a603011.svg";